import {
  headerHeight,
  PublicationLeftMenuList,
  stickyHeaderStyle,
  UiThemeBlueColor,
} from "../utils/constants";
import { useTranslation } from "react-i18next";
import { DownloadFileByFileStoreId } from "./DownloadFileByFileStoreId";
import { CommonPageUiLayer } from "./CommonPageUiLayer";
import { ReDirectToeKMC2 } from "./ReDirectToeKMC2";

export const scrollContainerStyle = {
  maxHeight: `calc(100vh - ${headerHeight + 150}px)`,
  //   minHeight: "300px",
  //   maxHeight: "700px",
  overflowY: "auto",
  overflowX: "auto",
  position: "relative",
  fontSize: "13px",
};

const RenderItem = (item) => {
  switch (item.type || "downloadByFileStoreId") {
    case "external":
      return (
        <a
          className="nav-link fontSizeClass"
          href={item.href}
          target={item.target || "_blank"}
          rel="noreferrer"
        >
          {item.label}
        </a>
      );

    case "redirect":
      return <ReDirectToeKMC2 label={item.label} />;

    default:
      return (
        <DownloadFileByFileStoreId
          fileStoreId={item.fileStoreId}
          label={item.label}
        />
      );
  }
};

export const DownloadListView = ({ list }) => (
  <ol style={scrollContainerStyle}>
    {list.map((item, index) => (
      <li key={item.fileStoreId || item.href || index}>{RenderItem(item)}</li>
    ))}
  </ol>
);

const DownloadTableView = ({
  list,
  t,
  firstColumnName,
  secondColumnName,
  thirdColumnName,
}) => (
  <div style={scrollContainerStyle}>
    <table
      border={0}
      align="center"
      cellPadding={2}
      cellSpacing={2}
      className="table table-bordered mb-0"
    >
      <thead>
        <tr bgcolor={UiThemeBlueColor} align="center" valign="middle">
          <th
            width="30%"
            className="text-white tble-brder-left"
            style={stickyHeaderStyle}
          >
            {t(firstColumnName)}
          </th>
          <th width="20%" className="text-white" style={stickyHeaderStyle}>
            {t(secondColumnName)}
          </th>
          <th
            width="50%"
            className="text-white tble-brder-right"
            style={stickyHeaderStyle}
          >
            {t(thirdColumnName)}
          </th>
        </tr>
      </thead>
      <tbody>
        {list.map(({ fileStoreId, label, date, subject }, index) => (
          <tr key={fileStoreId || index}>
            <td valign="top">
              <DownloadFileByFileStoreId
                fileStoreId={fileStoreId}
                label={label}
                classAdd={false}
              />
            </td>
            <td valign="top">{date}</td>
            <td valign="top">{t(subject)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const TableStructure = ({
  title = "Publication",
  heading,
  list,
  leftMenuList = PublicationLeftMenuList,
  longMenuList = false,
  columnNo = 1,
  firstColumnName = "Circular No",
  secondColumnName = "Date",
  thirdColumnName = "Subject",
}) => {
  const { t } = useTranslation();

  return (
    <CommonPageUiLayer
      leftNavsList={leftMenuList}
      isLeftNavsListLong={longMenuList}
    >
      {title && (
        <div className="inner-title2">
          <h3 className="fontSizeClass">{title}</h3>
        </div>
      )}
      <div className="col-lg-12 about-head1">
        <div className="dig-login1 dig-form" style={{ padding: "16px 0px" }}>
          {heading && (
            <div className="inner-title3">
              <h3
                className="fontSizeClass mb-2"
                style={{
                  display: "block",
                  color: "white",
                  fontWeight: "bold",
                  backgroundColor: "#302ba0",
                  padding: "10px 20px",
                }}
              >
                {heading}
              </h3>
            </div>
          )}

          {columnNo === 1 ? (
            <DownloadListView list={list} t={t} />
          ) : (
            <DownloadTableView
              list={list}
              t={t}
              firstColumnName={firstColumnName}
              secondColumnName={secondColumnName}
              thirdColumnName={thirdColumnName}
            />
          )}
        </div>
      </div>
    </CommonPageUiLayer>
  );
};
